module.exports = __webpack_public_path__ + "static/media/2.f2421b67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank/zsbank/2.png
// module id = 2695
// module chunks = 2